import * as React from "react";
const SVGComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_15137_23903)">
      <path
        d="M21.8753 6.25065H13.9691L17.3962 2.82357L16.667 2.08398L12.5003 6.25065L8.33366 2.08398L7.59408 2.82357L11.0316 6.25065H3.12533C1.97949 6.25065 1.04199 7.17773 1.04199 8.33398V20.834C1.04199 21.9798 1.97949 22.9173 3.12533 22.9173H21.8753C23.0212 22.9173 23.9587 21.9798 23.9587 20.834V8.33398C23.9587 7.17773 23.0212 6.25065 21.8753 6.25065ZM21.8753 20.834H3.12533V8.33398H21.8753V20.834ZM9.37533 10.4173V18.7507L16.667 14.584L9.37533 10.4173Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_15137_23903">
        <rect width={25} height={25} fill={color} />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
